<div class="thp-form-container">
  <form [formGroup]="r2rForm">
    <ng-container *ngIf="!hasLayout()">
      <div *ngIf="isFromGather() ? clientVMSSubInfo.vmsSubGatherInfo.rightToRepresentRequired && clientVMSSubInfo.r2rTypeId > 0 : clientVMSSubInfo.r2rTypeId > 0" class="field-group thp-form">
        <label class="field-label">{{"talent-happy-path.talent-vms.right-to-represent-agreement" | translate}}</label>
        <div class="r2r-agreement-field">
          <div class="r2r-terms-text" [innerHTML]="talentVMSSubInfo?.r2rAgreement"></div>
        </div>
      </div>
      <div *ngIf="isFromGather() ? clientVMSSubInfo.vmsSubGatherInfo.rightToRepresentRequired && clientVMSSubInfo.r2rTypeId > 0 : clientVMSSubInfo.r2rTypeId > 0" class="field-group thp-form">
        <div class="vms-header">
          <label class="field-label">{{"talent-happy-path.talent-vms.right-to-represent" | translate}}</label>
          <p class="overline">{{"talent-happy-path.talent-vms.required" | translate}}</p>
        </div>
        <div class="r2r-check-field">
          <div>
            <mat-checkbox formControlName="termsAccepted" id="right-to-represent-agree" class="checkbox"/>
          </div>
          <span class="r2r-terms-text">{{"talent-happy-path.talent-vms.right-to-represent-text" | translate}}</span>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="hasLayout() && parsedLayout">
      <ng-container *ngFor="let section of parsedLayout.sections">
        <ng-container *ngTemplateOutlet="sectionTpl; context: { $implicit: section }"></ng-container>
      </ng-container>
    </ng-container>

    <ng-template #sectionTpl let-section>
      <ng-container [ngSwitch]="section.type">
        <div *ngSwitchCase="R2RSectionType.ROLE_PILL" class="r2r-role-pill-set">
          <span class="r2r-role-pill">{{ jobTitle }}</span>
        </div>

        <h2 *ngSwitchCase="R2RSectionType.TITLE" class="r2r-section r2r-section--title">{{ section.copy }}</h2>

        <p *ngSwitchCase="R2RSectionType.SUBTITLE" class="r2r-section r2r-section--subtitle">{{ section.copy }}</p>

        <section *ngSwitchCase="R2RSectionType.CARD" class="r2r-card">
          <div class="r2r-card-header">
            <h3 class="r2r-card-title">{{ section.title }}</h3>
            <p class="overline" *ngIf="section.required">{{"talent-happy-path.talent-vms.required" | translate}}</p>
          </div>
          <p *ngIf="section.subtitle" class="r2r-card-subtitle">{{ section.subtitle }}</p>
          <ng-container *ngFor="let child of section.children">
            <ng-container *ngTemplateOutlet="sectionTpl; context: { $implicit: child }"></ng-container>
          </ng-container>
        </section>

        <section *ngSwitchCase="R2RSectionType.AGREEMENT_TEXT" class="r2r-section r2r-section--agreement">
          <div [innerHTML]="section.copy"></div>
        </section>

        <mat-accordion *ngSwitchCase="R2RSectionType.EXPANDABLE_JOB_DESCRIPTION" class="r2r-section--expandable-job-description">
          <mat-expansion-panel class="mat-elevation-z0">
            <mat-expansion-panel-header>
              <mat-panel-title>{{"talent-happy-path.talent-vms.view-job-description" | translate}}</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="job-description-body" [innerHTML]="jobDescription"></div>
          </mat-expansion-panel>
        </mat-accordion>


        <section *ngSwitchCase="R2RSectionType.AUTHORIZATION_STATEMENT" class="r2r-section r2r-section--authorization-statement">
          <h4 *ngIf="section.title" class="r2r-subsection-title">{{ section.title }}</h4>
          <div [innerHTML]="section.copy"></div>
        </section>

        <div *ngSwitchCase="R2RSectionType.CHECKBOX" class="r2r-section r2r-section--checkbox">
          <ng-container *ngIf="section.fieldKey">
            <mat-checkbox [formControlName]="section.fieldKey" [id]="'r2r-' + section.fieldKey" class="checkbox"/>
            <span class="r2r-check-label">{{ section.copy }}</span>
          </ng-container>
        </div>

        <section *ngSwitchCase="R2RSectionType.SIGNATURE_INPUT" class="r2r-section r2r-section--signature">
          <mat-form-field *ngIf="section.fieldKey" appearance="fill" class="signature-field">
            <mat-label>{{ section.copy }}</mat-label>
            <input matInput [formControlName]="section.fieldKey" [id]="'r2r-' + section.fieldKey" autocomplete="off"/>
          </mat-form-field>
        </section>

        <section *ngSwitchCase="R2RSectionType.TEXT_INPUT" class="r2r-section r2r-section--text-input">
          <mat-form-field *ngIf="section.fieldKey" appearance="fill" class="text-input-field">
            <mat-label>{{ section.copy }}</mat-label>
            <input matInput [formControlName]="section.fieldKey" [id]="'r2r-' + section.fieldKey" autocomplete="off"/>
          </mat-form-field>
        </section>
      </ng-container>
    </ng-template>
  </form>

  <div [ngClass]="!showBackButton ? 'button-container' : 'button-container double-button-container'">
    <button id="vms-submittal-back-button"
            *ngIf="showBackButton" mat-button
            class="double-custom-button back-button"
            (click)="goToPreviousPage()">
      <mat-icon>arrow_back</mat-icon>{{ "talent-happy-path.buttons.back" | translate }}
    </button>

    <ng-container *ngIf="!hasLayout(); else layoutCta">
      <button id="vms-submittal-next-button"
              mat-button
              [ngClass]="!showBackButton ? 'custom-button single-custom-button' : 'custom-button double-custom-button next-button'"
              [disabled]="disableSubmit()"
              (click)="goToNextPage()">
        <mat-icon>arrow_forward</mat-icon>{{ "talent-happy-path.buttons.next" | translate }}
      </button>
    </ng-container>

    <ng-template #layoutCta>
      <div class="r2r-sections-cta">
        <button id="vms-submittal-sections-continue"
                mat-flat-button
                color="primary"
                class="r2r-sections-cta-button"
                [disabled]="disableSubmit()"
                (click)="goToNextPage()">
          <mat-icon>check</mat-icon>{{ parsedLayout?.cta?.buttonLabel }}
        </button>
        <span *ngIf="disableSubmit() && parsedLayout?.cta?.disabledHint" class="r2r-sections-cta-hint">{{ parsedLayout?.cta?.disabledHint }}</span>
      </div>
    </ng-template>

    <button *ngIf="isFromGather()"
            mat-button class="later-button" (click)="doThisLater()">{{"talent-happy-path.buttons.do-later" | translate}}</button>
  </div>
</div>
